import React, { useState } from 'react';
import axios from '../../plugins/axios';

// components
import Form from '../../components/Form/Form';
import Button from '../../components/Button/Button';
import Alert from '../../components/Alert/Alert';
import Loader from '../../components/Loader/Loader';
import alert from '../../helpers/alert';

const defaultGrid = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' };

const AddServiceForm = ({ onSuccess, defaultCityId, grid }) => {
  const [succes, setSucces] = useState({});
  const [loading, setLoading] = useState(false);
  const [service, setService] = useState([
    { type: 'input', value: undefined, label: 'Название', name: 'title', placeholder: 'Укажите название услуги' },
    { type: 'input', label: 'Цена, KZT', name: 'price', placeholder: 'Укажите цену', inputType: 'number' },
    {
      type: 'input',
      label: 'Заметки/комментарии об услуге',
      name: 'comment',
      placeholder: 'Оставьте комментарий об услуге',
    },
    {
      type: 'selectCity',
      label: 'Город',
      name: 'cityId',
      value: defaultCityId,
    },
  ]);

  const addService = () => {
    setLoading(true);
    let object = new Object();
    service.map((item) => {
      object[item.name] = item.value;
    });
    axios
      .post('/api/crm/additional-services/addAdditionalService', { additionalService: object, comment: object.comment })
      .then((res) => {
        setSucces({ message: 'Услуга добавлена' });
        onSuccess && onSuccess(res?.data);
      })
      .catch((error) => {
        alert.error(error.response.data.errorMessage ?? JSON.stringify(error.response));
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading && <Loader />}
      <Form
        handlerSetState={setService}
        inputs={service}
        title={'Информация об услуге'}
        grid={grid || defaultGrid}
        border
      />
      <Button onClick={() => addService()} text={'Сохранить'} fill disabled={loading} />
      {succes.message && <Alert message={succes.message} />}
    </>
  );
};

export default AddServiceForm;
